import { Parchment } from 'quill/core';

export default new Parchment.ClassAttributor('span', 'span', {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['full', 'half'],
});
